import { ExpandMore, UnfoldLess, UnfoldMore } from '@material-ui/icons'
import { ReactNode, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import { lightGray2 } from '../../theme/colors'

interface AccordionProps {
  className?: string
  isExpanded?: boolean
  isDisabled?: boolean
  hideExpandIcon?: boolean
  details: ReactNode
  align?: 'flex-start' | 'center' | 'flex-end'
  children: (isExpanded: boolean) => ReactNode
  onClick?: (isExpanded: boolean) => void
  useUnfoldIcon?: boolean
}

const StyledAccordion = styled.div`
  width: 100%;
`

const StyledAccordionSummary = styled.div<{
  $hideExpandIcon?: boolean
  $align?: AccordionProps['align']
}>`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 15px;
  align-items: center;
  ${(p) =>
    p.$hideExpandIcon &&
    css`
      grid-template-columns: 1fr;
    `}

  ${(p) =>
    p.$align &&
    css`
      align-items: ${p.$align};
    `}
`
const StyledAccordionDetails = styled.div``

export const StyledAccordionExpandIcon = styled.div<{ $isExpanded: boolean }>`
  height: 24px;
  line-height: 1;
  transition: transform 0.2s;
  cursor: pointer;

  svg {
    transition: fill 0.3s;
    fill: ${lightGray2};
  }

  ${(p) =>
    p.$isExpanded &&
    css`
      transform: rotate(180deg);
    `}
`

export function Accordion(props: AccordionProps) {
  const [isExpanded, setIsExpanded] = useState(props.isExpanded ?? false)

  function handleClick() {
    if (props.isDisabled) return

    setIsExpanded(!isExpanded)
    props.onClick?.(!isExpanded)
  }

  useEffect(() => {
    setIsExpanded(props.isExpanded ?? false)
  }, [props.isExpanded])

  const ExpandIcon = props.useUnfoldIcon ? (props.isExpanded ? UnfoldLess : UnfoldMore) : ExpandMore

  return (
    <StyledAccordion className={props.className}>
      <StyledAccordionSummary
        onClick={handleClick}
        $hideExpandIcon={props.hideExpandIcon}
        $align={props.align}
      >
        {props.children(isExpanded)}
        {!props.hideExpandIcon && (
          <StyledAccordionExpandIcon $isExpanded={isExpanded} role="button" aria-label="expand">
            <ExpandIcon />
          </StyledAccordionExpandIcon>
        )}
      </StyledAccordionSummary>
      {isExpanded && <StyledAccordionDetails>{props.details}</StyledAccordionDetails>}
    </StyledAccordion>
  )
}
